<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-row>
            <b-col sm="12">
              <b-card header-class="redmfu">
                <div slot="header">
                  <strong v-if="thai_student==1">ตอนที่ 1 ข้อมูลทั่วไป</strong>
                  <strong v-else>Part 1 General Data</strong>
                </div>
                <div v-for="item in items" v-bind:key="item.QUESTION_PK">
                  <div v-if="item.QUESTION_PK==100">
                    <strong>11. {{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <div v-if="selected_pr1==1">1 : {{ ans100_1 }}<br></div>
                    <div v-if="selected_pr2==1">2 : {{ ans100_2 }}<br></div>
                    <div v-if="selected_pr3==1">3 : {{ ans100_3 }}<br></div>
                    <div v-if="selected_pr4==1">4 : {{ ans100_4 }}<br></div>
                    <div v-if="selected_pr5==1">5 : {{ ans100_5 }}<br></div>
                    <div v-if="selected_pr6==1">6 : {{ ans100_6 }}<br></div>
                    <div v-if="selected_pr7==1">7 : {{ ans100_7 }}<br></div>
                    <div v-if="selected_pr8==1">8 : {{ ans100_8 }}<br></div>
                    <div v-if="selected_pr9==1">9 : {{ ans100_9 }}<br></div>
                    <div v-if="selected_pr10==1">10 : {{ ans100_10 }}<br></div>
                    <div v-if="selected_pr11==1">11 : {{ ans100_11 }}<br></div>
                    <div v-if="selected_pr12==1">12 : {{ ans100_12 }}<br></div>
                    <div v-if="selected_pr13==1">13: {{ ans100_13 }}<br></div>
                    <div v-if="selected_pr14==1">14 : {{ ans100_14 }}<br></div>
                    <div v-if="selected_pr15==1">15 : {{ ans100_15 }} : <u>{{ qn_pr_txt }}</u></div>

                  </div>
                  <div v-if="item.QUESTION_PK==1">
                    <strong> 13.{{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <p>{{ selected_military }} : {{ ans1 }}</p>
                  </div>
                  <div v-if="item.QUESTION_PK==2">
                    <strong> 14.{{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <p>{{ selected_ordinate }} : {{ ans2 }}</p>
                  </div>
                  <div v-if="item.QUESTION_PK==3">
                    <strong>14. {{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <p>{{ selected_work_status }} : {{ ans3 }}</p>
                  </div>
                  <div v-if="item.QUESTION_PK==4">
                    <strong>15. {{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <p>{{ qn_income }} : {{ ans4 }}</p>
                  </div>
                </div>
<!--                <div align="center">-->
<!--                  <b-col cols="7" sm="4" md="2" xl class="mb-3 mb-xl-0">-->

<!--                      <b-button block variant="primary" @click="onSubmit"><i class="fa fa-arrow-circle-o-right"></i>-->
<!--                        Next-->
<!--                      </b-button>-->
<!--                  </b-col>-->
<!--                </div>-->

                <div slot="footer" class="text-right" >
                  <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                    <i class="fa fa-arrow-circle-o-left"></i> Back
                  </b-button>
                  <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                    <i class="fa fa-arrow-circle-o-right"></i> Next
                  </b-button>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
        </b-col>
      </b-row>
    </div>

    <b-modal
      title="You didn’t fill your information completely"
      class="modal-danger"
      v-model="dangerModal"
      @ok="dangerModal = false"
      ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      student: {},
      std_id: "",
      selected_military: "",
      selected_ordinate: "",
      selected_work_status: "",
      qn_income: "",
      numEror: 0,
      sex: "",
      studentCode: "",
      thai_student: "",
      prefixName: "",
      studentName: "",
      studentSurname: "",
      studentNameEng: "",
      studentSurnameEng: "",
      prefixNameEng: "",
      levelGroupNameEng: "",
      facultyName: "",
      facultyNameEng: "",
      departmentName: "",
      departmentNameEng: "",
      current_erorrtxt: "",
      ans1: "",
      ans2: "",
      ans3: "",
      ans4: "",
      ans_name: [],
      dangerModal: false,
      items: [],
      actionUpdate: 10,
      selected_pr1: "",
      selected_pr2: "",
      selected_pr3: "",
      selected_pr4: "",
      selected_pr5: "",
      selected_pr6: "",
      selected_pr7: "",
      selected_pr8: "",
      selected_pr9: "",
      selected_pr10: "",
      selected_pr11: "",
      selected_pr12: "",
      selected_pr13: "",
      selected_pr14: "",
      selected_pr15: "",
      ans100_1: "",
      ans100_2: "",
      ans100_3: "",
      ans100_4: "",
      ans100_5: "",
      ans100_6: "",
      ans100_7: "",
      ans100_8: "",
      ans100_9: "",
      ans100_10: "",
      ans100_11: "",
      ans100_12: "",
      ans100_13: "",
      ans100_14: "",
      ans100_15: "",
      qn_pr_txt: "",
    };
  },

  methods: {
    getAns(question, ans, thaistudent) {
      api
        .getSybytedesByAns(question, ans, thaistudent)
        .then(res => {
          // console.log("length==", res.data.data.length);
          var currentSt = res.data.data[0];
          if (res.data.data.length > 0) {
            if (question == "QN_MILITARY_STATUS") {
              this.ans1 = res.data.data[0].BYTEDES;
              // console.log("this.ans1121== ", this.ans1);
            }
            if (question == "QN_ORDINATE_STATUS") {
              this.ans2 = res.data.data[0].BYTEDES;
              // console.log("this.ans2121== ", this.ans2);
            }
            if (question == "QN_WORK_STATUS") {
              this.ans3 = res.data.data[0].BYTEDES;
              // console.log("this.ans3121== ", this.ans3);
            }
            if (question == "QN_INCOME") {
              this.ans4 = res.data.data[0].BYTEDES;
              // console.log("this.ans3121== ", this.ans3);
            }
            if (question == "QN_PR1") {
              this.ans100_1 = res.data.data[0].BYTEDES;
              // console.log("this.ans100_1== ", this.ans100_1);
            }
            if (question == "QN_PR2") {
              this.ans100_2 = res.data.data[0].BYTEDES;
              // console.log("this.ans100_2== ", this.ans100_2);
            }
            if (question == "QN_PR3") {
              this.ans100_3 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR4") {
              this.ans100_4 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR5") {
              this.ans100_5 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR6") {
              this.ans100_6 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR7") {
              this.ans100_7 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR8") {
              this.ans100_8 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR9") {
              this.ans100_9 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR10") {
              this.ans100_10 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR11") {
              this.ans100_11 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR12") {
              this.ans100_12 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR13") {
              this.ans100_13 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR14") {
              this.ans100_14 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PR15") {
              this.ans100_15 = res.data.data[0].BYTEDES;
            }
          }
        })
        .catch(err => {
          console.log(2);
          console.log("getSybytedesByAns", err.toString());
        });
    },
    onBack(){
      this.$router.push("main");
    },
    onSubmit() {
      // var student = {};
      // student = this.setStudent();
      // console.log("student save=", student);
      // this.numEror = this.getErrorTxt();
      // console.log("numEror save=", this.numEror);
      // if (this.numEror == 0) {
      //   if (this.actionUpdate == 0) {
      //     // save
      //     this.$router.push("/General");
      //   } else if (this.actionUpdate == 1) {
      //     // update
      //     this.onUpdateData(student);
      //   }else{
      //     this.$router.push("/Logout");
      //   }
      // }
      if (this.qn_income == 1 || this.qn_income == 2 || this.qn_income == 3) {
        this.$router.push("employment2");
      } else if (this.qn_income == 4) {
        this.$router.push("employment3");
      }
      // this.$router.push("Employment0");
    },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          var currentSt = res.data.data[0];
          if (res.data.data.length == 1) {
            this.actionUpdate = 1;
            // console.log("res==", res);
            this.std_id = studentid;
            this.thai_student = currentSt.THAI_STUDENT;
            this.sex = currentSt.SEX;
            this.selected_pr1 = currentSt.QN_PR1;
            if (this.selected_pr1 == 1) {
              this.getAns(
                "QN_PR1",
                1,
                this.thai_student
              );
            }
            this.selected_pr2 = currentSt.QN_PR2;
            if (this.selected_pr2 == 1) {
              this.getAns(
                "QN_PR2",
                2,
                this.thai_student
              );
            }
            this.selected_pr3 = currentSt.QN_PR3;
            if (this.selected_pr3 == 1) {
              this.getAns(
                "QN_PR3",
                3,
                this.thai_student
              );
            }
            this.selected_pr4 = currentSt.QN_PR4;
            if (this.selected_pr4 == 1) {
              this.getAns(
                "QN_PR4",
                4,
                this.thai_student
              );
            }
            this.selected_pr5 = currentSt.QN_PR5;
            if (this.selected_pr5 == 1) {
              this.getAns(
                "QN_PR5",
                5,
                this.thai_student
              );
            }
            this.selected_pr6 = currentSt.QN_PR6;
            if (this.selected_pr6 == 1) {
              this.getAns(
                "QN_PR6",
                6,
                this.thai_student
              );
            }
            this.selected_pr7 = currentSt.QN_PR7;
            if (this.selected_pr7 == 1) {
              this.getAns(
                "QN_PR7",
                7,
                this.thai_student
              );
            }
            this.selected_pr8 = currentSt.QN_PR8;
            if (this.selected_pr8 == 1) {
              this.getAns(
                "QN_PR8",
                8,
                this.thai_student
              );
            }
            this.selected_pr9 = currentSt.QN_PR9;
            if (this.selected_pr9 == 1) {
              this.getAns(
                "QN_PR9",
                9,
                this.thai_student
              );
            }
            this.selected_pr10 = currentSt.QN_PR10;
            if (this.selected_pr10 == 1) {
              this.getAns(
                "QN_PR10",
                10,
                this.thai_student
              );
            }
            this.selected_pr11 = currentSt.QN_PR11;
            if (this.selected_pr11 == 1) {
              this.getAns(
                "QN_PR11",
                11,
                this.thai_student
              );
            }
            this.selected_pr12 = currentSt.QN_PR12;
            if (this.selected_pr12 == 1) {
              this.getAns(
                "QN_PR12",
                12,
                this.thai_student
              );
            }
            this.selected_pr13 = currentSt.QN_PR13;
            if (this.selected_pr13 == 1) {
              this.getAns(
                "QN_PR13",
                13,
                this.thai_student
              );
            }
            this.selected_pr14 = currentSt.QN_PR14;
            if (this.selected_pr14 == 1) {
              this.getAns(
                "QN_PR14",
                14,
                this.thai_student
              );
            }
            this.selected_pr15 = currentSt.QN_PR15;
            if (this.selected_pr15 == 1) {
              this.qn_pr_txt = currentSt.QN_PR15_TXT;
              this.getAns(
                "QN_PR15",
                15,
                this.thai_student
              );
            }
            this.selected_military = currentSt.QN_MILITARY_STATUS;
            this.selected_ordinate = currentSt.QN_ORDINATE_STATUS;
            this.selected_work_status = currentSt.QN_WORK_STATUS;
            this.qn_income = currentSt.QN_INCOME;
            // console.log("thai_student==", this.thai_student);
            // console.log("sex==", this.sex);
            this.getQuestion(1, this.sex, this.thai_student);
            if (this.thai_student == 1 && this.sex == "M") {
              this.getAns(
                "QN_MILITARY_STATUS",
                this.selected_military,
                this.thai_student
              );
              this.getAns(
                "QN_ORDINATE_STATUS",
                this.selected_ordinate,
                this.thai_student
              );
            }
            this.getAns(
              "QN_WORK_STATUS",
              this.selected_work_status,
              this.thai_student
            );
            this.getAns(
              "QN_INCOME",
              this.qn_income,
              this.thai_student
            );

          } else {
            this.actionUpdate = 0;
            this.$router.push("/logout");
          }
        })
        .catch(err => {
          this.actionUpdate = 10;
          console.log("getCurrentStudent", err.toString());
          this.$router.push("/logout");
        });
    },
    // getStudentByID(studentId) {
    //   api
    //     .getStudentByID(studentId)
    //     .then(res => {
    //       // console.log(res);
    //       var info = res.data.data[0];
    //       this.sex = info.SEX;
    //       this.thai_student = info.THAI_STUDENT;
    //       this.studentId = info.STUDENTID;
    //       // console.log("studentId==", this.studentId);
    //       this.std_id = info.STUDENTID;
    //       // console.log("std_id==", this.std_id);
    //       this.studentCode = info.STUDENTCODE;
    //       this.prefixName = info.PREFIXNAME;
    //       this.studentSurname = info.STUDENTSURNAME;
    //       this.studentName = info.STUDENTNAME;
    //       this.prefixNameEng = info.PREFIXNAMEENG;
    //       this.studentNameEng = info.STUDENTNAMEENG;
    //       this.studentSurnameEng = info.STUDENTSURNAMEENG;
    //       this.LEVELGROUPNAME = info.LEVELGROUPNAME;
    //       this.departmentName = info.DEPARTMENTNAME;
    //       this.departmentNameEng = info.DEPARTMENTNAMEENG;
    //       this.facultyName = info.FACULTYNAME;
    //       this.facultyNameEng = info.FACULTYNAMEENG;
    //       this.levelGroupNameEng = info.LEVELGROUPNAMEENG;
    //       // this.getQuestion(1, this.sex, this.thai_student);
    //     })
    //     .catch(err => {
    //       console.log("2 getStudentByID");
    //       console.log("2", err.toString());
    //     });
    // },
    setStudent: function () {
      var student = {}
      student.std_id = this.studentId;
      student.selected_military = this.selected_military;
      student.selected_ordinate = this.selected_ordinate;
      student.selected_work_status = this.selected_work_status;
      //console.log("setStudent==", student);
      return student;
    },
    getErrorTxt: function () {
      this.current_erorrtxt = "";
      this.numEror = 0;
      if (this.selected_military == "") {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/สถานะเกณฑ์ทหาร"
            : this.current_erorrtxt + "/";
      }
      if (this.selected_ordinate == "") {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/สถานะการเป็นนักบวช"
            : this.current_erorrtxt + "/";
      }
      if (this.selected_work_status == "") {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/สถานภาพการทำงาน"
            : this.current_erorrtxt + "/Work status";
      }
      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      return this.numEror;
    },

    nextPart() {
      console.log(" error", this.selected_work_status);
      /*  if (
          this.selected_work_status == 1 ||
          this.selected_work_status == 2 ||
          this.selected_work_status == 5 ||
          this.selected_work_status == 6 ||
          this.selected_work_status == 7
        ) {
          this.$router.push("/Part2");
        } else if (this.selected_work_status == 3) {
          this.$router.push("/Part3");
        } else if (this.selected_work_status == 4) {
          this.$router.push("/Part4");
        } else {
          this.$router.push("/Part1");

        } */

      /*if (
        this.qn_income == 1 ||
        this.qn_income == 2 ||
        this.qn_income == 3

      ) {
        this.$router.push("/Part2");
      } else if (this.qn_income == 4) {
        this.$router.push("/Part3");
      } else {
        this.$router.push("/Part1");

      } */
    },
    onUpdateData() {
      api
        .updateStudentPart1(this.student)
        .then(res => {
          console.log(res);
          this.message = res.message;
          console.log("updatePart1 ผ่าน", this.studentId);
          this.$store.dispatch("setUser", {
            work_status: this.selected_work_status
          });
          this.nextPart();
        })
        .catch(err => {
          console.log(2);
          console.log("updatePart1 error", err.toString());
        });
    },
    getQuestion: function (section, sex, thaistudent) {
      api
        .getQuestionBySection(section, sex, thaistudent)
        .then(res => {
          this.items = res.data.data;
          // console.log(this.items);
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    }
  },
  mounted() {
  },
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/logout");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.std_id);

  }
};
</script>
<style>
.redmfu {
  background-color: #960018;
  color: white;
}
</style>
